import React, { useState, useEffect } from "react";
import { useParams, Link } from "react-router-dom";
import AdminHeader from "./AdminHeader";
import AdminNavigation from "./AdminNavigation";
import AdminFooter from "./AdminFooter";
import { ToastContainer, toast } from "react-toastify";
import { getManufacturerName } from "../../Utils/commonFunctions";
import { getSiteList, deleteData } from "../../Utils/adminFunctions";
import dataTableGrid from "../DataTableGrid";
let AdminListSites = () => {
  const [listSites, setListSites] = useState([]);
  const [manufacturerName, setManufacturerName] = useState("");
  const { mID } = useParams();
  useEffect(() => {
    getcompanyname();
    managesitelist();
  }, []);
  const getcompanyname = async () => {
    const tempManufacturerName = await getManufacturerName(mID);
    setManufacturerName(tempManufacturerName);
  };
  const managesitelist = async () => {
    const tempSiteList = await getSiteList(mID);
    setListSites(tempSiteList);
    dataTableGrid({
      data_table_id: "#sitelist",
      paginate: false,
      copy_option: [0, 1, 2, 3, 4],
      csv_option: [0, 1, 2, 3, 4],
      print_option: [0, 1, 2, 3, 4],
      sort_option: [5],
    });
  };
  let handleDeleteRecord = async () => {
    let sID = document.getElementById("deleteListsite").value;
    const response = await deleteData(sID, "SITES");
    if (response.status) {
      if (response.status == "success") {
        toast.success(response.message, { autoClose: 1500 });
        document.getElementById("close_modal").click();
        managesitelist();
      } else {
        toast.warning(response.message, { autoClose: 1500 });
        document.getElementById("close_modal").click();
      }
    } else {
      toast.error(response, { autoClose: 1500 });
      document.getElementById("close_modal").click();
    }
  };

  return (
    <div>
      <ToastContainer></ToastContainer>
      <div className="modal fade show" id="modal-default" arial-modal="true">
        <input type="hidden" id="deleteListsite" value=""></input>
        <div className="modal-dialog">
          <div className="modal-content">
            <div className="modal-header">
              <h4 className="modal-title">Confirm delete</h4>
              <button
                type="button"
                className="close"
                data-dismiss="modal"
                aria-label="Close"
                id="close_modal"
              >
                <span aria-hidden="true">×</span>
              </button>
            </div>
            <div className="modal-body">
              <p>Are you sure you want to delete this record?</p>
            </div>
            <div className="modal-footer">
              <button
                type="button"
                data-dismiss="modal"
                className="btn btn-sm btn-dark"
              >
                Cancel
              </button>
              <button
                type="button"
                className="btn btn-sm btn-danger"
                onClick={() => handleDeleteRecord()}
              >
                Delete
              </button>
            </div>
          </div>
        </div>
      </div>
      <div className="wrapper">
        <div>
          <AdminHeader />
          <AdminNavigation />
          <div className="content-wrapper">
            <div className="content-header"></div>
            <section className="content">
              <div className="container-fluid">
                <div className="row">
                  <div className="col-md-12">
                    <div className="card">
                      <div className="card-header">
                        <div className="row">
                          <div className="col-md-6">
                            <h3 className="card-title card-header-link custom-link-primary">
                              <b>{manufacturerName}</b>
                            </h3>
                          </div>
                          <div className="col-md-6">
                            <h3 className="card-title pull-right mb-2">
                              <Link
                                to={"/AdminAddSite/" + mID}
                                className="btn btn-sm custom-btn-primary"
                              >
                                <i className="fa fa-plus"></i> Add Site
                              </Link>{" "}
                              <Link
                                to="/AdminListManufacturer"
                                className="btn btn-sm custom-btn-primary"
                              >
                                <i className="fa fa-arrow-left"></i> Back
                              </Link>
                            </h3>
                          </div>
                        </div>
                      </div>
                      <div className="card-body">
                        <table
                          id="sitelist"
                          className="table table-bordered table-striped"
                        >
                          <thead>
                            <tr>
                              <th>S. No.</th>
                              <th>Site Name</th>
                              <th>Country</th>
                              <th>State</th>
                              <th>Created On</th>
                              <th>Action</th>
                            </tr>
                          </thead>
                          <tbody>{listSites}</tbody>
                        </table>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </section>
          </div>
          <AdminFooter />
        </div>
      </div>
    </div>
  );
};

export default AdminListSites;
